// constants/clips.js
// Created: 2026-03-11 15:30:00 EST
// Updated: 2026-03-11 16:30:00 EST
// Project: Giving Words to Voices
// Author: Michael Schwarz
// Version: 1.0.0
//
// Clip constants: categories and status styles for the highlight clip workflow.

export const CLIP_CATEGORIES = {
  arrival:          { label: 'Arrival',          color: '#ef4444' },
  family:           { label: 'Family',           color: '#ec4899' },
  liberation:       { label: 'Liberation',       color: '#22c55e' },
  resistance:       { label: 'Resistance',       color: '#f59e0b' },
  reflection:       { label: 'Reflection',       color: '#8b5cf6' },
  humanity:         { label: 'Humanity',          color: '#06b6d4' },
  loss:             { label: 'Loss',              color: '#6b7280' },
  memorable_quote:  { label: 'Memorable Quote',   color: '#f472b6' },
};

export const CLIP_STATUS_STYLE = {
  proposed: { bg: '#f59e0b20', color: '#f59e0b', label: 'Proposed' },
  approved: { bg: '#22c55e20', color: '#22c55e', label: 'Approved' },
  flagged:  { bg: '#ef444420', color: '#ef4444', label: 'Flagged'  },
  rejected: { bg: '#6b728020', color: '#6b7280', label: 'Rejected' },
  exported: { bg: '#007aff20', color: '#007aff', label: 'Exported' },
};
